import { CheckIcon, DaButton, Image, Breadcrumb } from '@paygreen/paygreen-ui';

import styled from 'styled-components';

export const CheckIconStyled = styled(CheckIcon)`
    border: 2px solid #fff;
    position: absolute;
    top: -10px;
    right: -10px;
`;

export const ImageStyled = styled(Image)`
    width: 46px;
    height: 46px;
    cursor: ${(props) => (props.userProjects ? 'pointer' : 'initial')};
`;

export const DaButtonStyled = styled(DaButton)`
    cursor: ${(props) => (props.userProjects ? 'pointer' : 'initial')};
`;

export const BreadcrumbStyled = styled(Breadcrumb)`
    letter-spacing: 0;
    text-transform: lowercase;

    a:first-letter {
        text-transform: capitalize;
    }
`;
